<div class="assign-template-dialog">
  <div class="dialog-content">
    @if (dataLoaded) {
      <div class="form-container">
        <!-- Template Selection Section -->
        <div class="field">
          <label for="templateSelect">Select Templates</label>
          <p-multiSelect
            id="templateSelect"
            [options]="availableTemplates"
            [(ngModel)]="selectedTemplateIds"
            optionLabel="displayLabel"
            optionValue="templateId"
            placeholder="Choose templates to assign"
            [showToggleAll]="true"
            [showHeader]="true"
            [filter]="true"
            filterBy="displayLabel"
            class="w-100"
            [style]="{ width: '100%' }"
            [disabled]="isSaving"
            appendTo="body">
          </p-multiSelect>
        </div>

        @if(selectedTemplateIds.length > 0) {
          <div class="selected-count">
            <small>{{ selectedTemplateIds.length }} template(s) selected</small>
          </div>
        }

        <!-- Assigned Templates List Section -->
        @if (assignedTemplates.length > 0) {
          <div class="assigned-templates-section">
            <label class="section-label">Assigned Templates</label>
            <div class="assigned-templates-list">
              @for (template of assignedTemplates; track template.templateId; let i = $index) {
                <div class="template-row">
                  <div class="template-info">
                    <div class="template-name">{{ getTemplateDisplayName(template) }}</div>
                  </div>
                  <div class="remove-button">
                    <p-button
                      icon="pi pi-arrow-up"
                      [text]="true"
                      [rounded]="true"
                      (onClick)="moveTemplateUp(i)"
                      [disabled]="isSaving || i === 0"
                      pTooltip="Move up">
                    </p-button>
                    <p-button
                      icon="pi pi-arrow-down"
                      [text]="true"
                      [rounded]="true"
                      (onClick)="moveTemplateDown(i)"
                      [disabled]="isSaving || i === assignedTemplates.length - 1"
                      pTooltip="Move down">
                    </p-button>
                    <p-button
                      icon="pi pi-trash"
                      [text]="true"
                      [rounded]="true"
                      severity="danger"
                      (onClick)="removeTemplate(template.templateId!)"
                      [disabled]="isSaving"
                      pTooltip="Remove template">
                    </p-button>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- Empty State -->
        @if (assignedTemplates.length === 0) {
          <div class="empty-state">
            <i class="pi pi-file-check text-4xl text-400 mb-2"></i>
            <p class="text-600">No templates assigned yet</p>
            <p class="text-500 text-sm">Select templates from the dropdown above to assign them to the project</p>
          </div>
        }
      </div>
    }

    @if (!dataLoaded) {
      <div class="loading-state">
        <i class="pi pi-spin pi-spinner text-4xl text-400"></i>
        <p class="text-600">Loading templates...</p>
      </div>
    }
  </div>

  <div class="dialog-footer">
    <p-button
      label="Cancel"
      icon="pi pi-times"
      [outlined]="true"
      (onClick)="cancel()"
      [disabled]="isSaving">
    </p-button>
    <p-button
      label="Assign Templates"
      icon="pi pi-check"
      (onClick)="save()"
      [disabled]="!dataLoaded || selectedTemplateIds.length === 0 || isSaving"
      [loading]="isSaving">
    </p-button>
  </div>
</div>
